import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { PanelPatientDataDisplay } from '../sharedPanelComponents/PanelPatientDataDisplay'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { CSpinner } from '@coreui/react-pro'
import {
  getPatientClinicalInfo,
  getPatientInsuranceInfo,
  getPatientRadiologyLabInfo,
} from '../../../../../components/common/shared/sharedPatientLogic'
import {
  PatientClinicalDisplay,
  PatientInsuranceDisplay,
  PatientLabRadiologyDisplay,
} from '../../../../../components/common/shared/sharedPatientCode'
import { getPatientData } from '../../../../../helper/backendHelper'
import PCCFacilityNoteDisplay from '../../../PatientDetails/PCCComponents/PCCFacilityNoteDisplay'

export default function PanelPCCInfo() {
  const patientId = useSelector((state) => state.sidePanel.panelEncounter?.patient_id)
  const dos = useSelector((state) => state.sidePanel.panelEncounter?.service_date_from)

  const [clinicalInfoData, setClinicalInfoData] = useState({})
  const [labsAndRadioInfoData, setLabsAndRadioInfoData] = useState({})
  const [insuranceInfoData, setInsuranceInfoData] = useState({})
  const [patientData, setPatientData] = useState({})
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (patientId && dos) {
      Promise.allSettled([
        getPatientClinicalInfo(patientId, setClinicalInfoData),
        getPatientRadiologyLabInfo(patientId, null, setLabsAndRadioInfoData),
        getPatientInsuranceInfo(patientId, setInsuranceInfoData),
        getPatientData(patientId).then((res) => {
          setPatientData(res?.data?.[0])
        }),
      ]).then(() => {
        setIsLoading(false)
      })
    }
  }, [patientId, dos])

  return (
    <div id={'PanelPCCInfo'} className={`display-box `}>
      {isLoading ? (
        <div className={'d-flex justify-content-center mt-2'}>
          <CSpinner />
        </div>
      ) : (
        <Tabs className={'row-tabs'} disableUpDownKeys>
          <TabList className={'row-tabs-list'}>
            <Tab>Clinical</Tab>
            <Tab>Labs & Rad</Tab>
            <Tab>Facility Notes</Tab>
            <Tab>Insurance</Tab>
          </TabList>
          <hr />

          <TabPanel>
            <PatientClinicalDisplay
              clinicalInfoData={clinicalInfoData}
              DisplayFunction={PanelPatientDataDisplay}
            />
          </TabPanel>
          <TabPanel>
            <PatientLabRadiologyDisplay
              labsAndRadioInfoData={labsAndRadioInfoData}
              patientId={patientId}
            />
          </TabPanel>
          <TabPanel>
            <PCCFacilityNoteDisplay patientDetails={patientData} />
          </TabPanel>
          <TabPanel>
            <PatientInsuranceDisplay
              insuranceInfoData={insuranceInfoData}
              DisplayFunction={PanelPatientDataDisplay}
            />
          </TabPanel>
        </Tabs>
      )}
    </div>
  )
}
